import api from "./api";

export const getAllJobs = ({ queryKey }) => {
  const [_key, { query }] = queryKey;

  return api.get(`/jobs${query ? `?${query}` : ""}`);
};

export const postJob = (data) => {
  return api.post("/jobs", data);
};

export const getJob = (data) => {
  return api.get("/jobs/" + data);
};

export const getJobFacilities = (data) => {
  return api.get("/jobs/" + data + "/facilities");
};

export const updateJob = (data) => {
  return api.put("/jobs/" + data.uuid, data);
};

export const deleteJob = (data) => {
  return api.delete("/jobs/" + data);
};

export const applyJob = (data) => {
  return api.post("/jobs/" + data.uuid + "/apply");
};

export const getJobApplications = (data) => {
  return api.get("/jobs/" + data + "/applications");
};

export const getJobQR = (data) => {
  return api.get("/jobs/" + data + "/qr");
};

export const putJobQR = (data) => {
  return api.put("/jobs/qr/" + data.id + "/scan");
};

export const approveJob = (data) => {
  return api.post("/applications/" + data.uuid + "/approve");
};

export const reapproveJob = (data) => {
  return api.post("/applications/" + data.uuid + "/reapprove");
};

export const rejectJob = (data) => {
  return api.post("/applications/" + data.uuid + "/reject");
};

export const getApplications = ({ queryKey } = {}) => {
  // Handle both old and new calling patterns
  if (!queryKey || !queryKey[1]) {
    return api.get("/applications");
  }
  const [_key, { query }] = queryKey;
  return api.get(`/applications${query ? `?${query}` : ""}`);
};

export const getApplication = ({ queryKey }) => {
  const [_key, { query }] = queryKey;
  if (query) {
    return api.get(`/applications/${query}`);
  }
};

export const getBanks = () => {
  return api.get("/payment/banks");
};

export const postBank = (data) => {
  return api.post("/payment/fpx", data);
};
export const getCancellationList = (data) => {
  return api.get("/cancel_requests");
};

export const acceptCancellation = (data) => {
  return api.post("/cancel_requests/" + data.uuid + "/accept");
};

export const rejectCancellation = (data) => {
  return api.post("/cancel_requests/" + data.uuid + "/reject", {
    ...data.data,
  });
};
export const submitCancellation = (data) => {
  return api.post("/jobs/" + data.uuid + "/cancel", {
    ...data.data,
  });
};

export const getLocation = ({ queryKey }) => {
  const [_key, { query, country }] = queryKey;
  if (query) {
    // Use country name if provided, otherwise default to Malaysia
    const countryName = country || "Malaysia";
    return api.get(`/clinics/auto_complete?query=${query},${countryName}`);
  }
};

export const submitDoctorRating = (data) => {
  return api.post("/jobs/" + data.jobID + "/rate", {
    ...data.data,
  });
};

export const postCompleteJob = (data) => {
  return api.post("/jobs/" + data.jobID + "/force_complete");
};

export const postNotifyDoctors = (data) => {
  return api.post("/jobs/" + data.jobID + "/notify");
};

export const exportTransactions = (data) => {
  return api.post(
    "/transactions/download",
    {
      ...data.data,
    },
    {
      responseType: "blob",
    }
  );
};

// Helper function to create jobs for multiple countries with progress tracking
export const createJobsForCountries = async (jobData, countries, onProgress) => {
  const results = [];
  const total = countries.length;
  let completed = 0;

  // Initialize progress tracking
  const progressCountries = countries.map(country => ({
    code: country,
    status: 'pending',
    error: null,
  }));

  // Notify initial progress
  if (onProgress) {
    onProgress({
      total,
      completed,
      countries: progressCountries,
    });
  }

  // Create jobs for each country
  for (let i = 0; i < countries.length; i++) {
    const country = countries[i];

    // Update status to in_progress
    progressCountries[i].status = 'in_progress';
    if (onProgress) {
      onProgress({
        total,
        completed,
        countries: [...progressCountries],
      });
    }

    try {
      // Create job for this country
      const response = await postJob({
        ...jobData,
        country: country,
      });

      // Success
      progressCountries[i].status = 'success';
      results.push({
        country,
        status: 'success',
        data: response.data,
      });
    } catch (error) {
      // Failed
      progressCountries[i].status = 'failed';
      progressCountries[i].error = error.response?.data?.message || 'Failed to create job';
      results.push({
        country,
        status: 'failed',
        error: error.response?.data?.message || 'Failed to create job',
      });
    }

    completed++;

    // Update progress
    if (onProgress) {
      onProgress({
        total,
        completed,
        countries: [...progressCountries],
      });
    }

    // Add a small delay between requests to avoid overwhelming the server
    if (i < countries.length - 1) {
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  }

  return results;
};
